import React from 'react';

export function TypeAndOriginFormatter(shumaType, shumaOrigin) {
  return (
    <div className="font-weight-bolder">
      {shumaType && (
        <div>{shumaType}</div>
      )}
      {shumaOrigin && (
        <div>{shumaOrigin}</div>
      )}
    </div>
  );
}